import { useState } from "react";
import FinanceTablesContainer from "../../containers/Tables/FinanceTablesContainer";
import DatePicker from "../../components/DatePicker";

const tabData = [
  {
    title: "Productos",
    optionName: "product",
  },
  {
    title: "Arriendos",
    optionName: "rent",
  },
  {
    title: "Remuneraciones",
    optionName: "salary",
  },
  {
    title: "Banco",
    optionName: "bank",
  },
  {
    title: "Otros",
    optionName: "other",
  },
];
const EgresosPage = () => {
  const nowDate = new Date();
  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });
  const [tipoEgreso, setTipoEgreso] = useState(tabData[0]);
  return (
    <div className="content">
      <div className="subfinanzas-header">
        <div className="d-flex align-items-center gap-4">
          <h1>Finanzas - Egresos</h1>
          <DatePicker dateValues={dateValues} setDateValues={setDateValues} />
        </div>
        <div className="subfinanzas-header-tabs">
          <ul className="nav nav-tabs">
            {tabData.map((tab) => (
              <li
                className="nav-item"
                key={tab.optionName}
                onClick={() => setTipoEgreso(tab)}
              >
                <span
                  className={
                    "nav-link " +
                    (tipoEgreso.optionName === tab.optionName ? "active" : "")
                  }
                >
                  {tab.title}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="subfinanzas-content">
        <FinanceTablesContainer dateValues={dateValues} activeType={tipoEgreso} transactionType="egreso" />
      </div>
    </div>
  );
};

export default EgresosPage;
